import Vue from 'vue'
import Router from 'vue-router'
// 引入各业务模块路由数据
// 手机端
import MemberCenterRouters from '@/views/mobile/MemberCenter/routers/index'
import PublicAppRouters from '@/views/mobile/PublicApp/routers/index'
import RechargeCenterRouters from '@/views/mobile/RechargeCenter/routers/index'
import PayCenterRouters from '@/views/mobile/PayCenter/routers/index'
import BillListRouters from '@/views/mobile/BillList/routers/index'
import CouponListRouters from '@/views/mobile/CouponList/routers/index'
import GoodsListRouters from '@/views/mobile/GoodsList/routers/index'

// 管理端
import UserMgmtRouters from '@/views/webpc/UserMgmt/login/routers/index'
import RealAppRouters from '@/views/webpc/CashierDesk/RealApp/routers/index'
import CashRechargeAppRouters from '@/views/webpc/CashierDesk/CashRechargeApp/routers/index'
import CashRecordAppRouters from '@/views/webpc/CashierDesk/CashRecordApp/routers/index'
import RechargeRecordAppRouters from '@/views/webpc/CashierDesk/RechargeRecordApp/routers/index'
import CertificationRecordAppRouters from '@/views/webpc/CashierDesk/CertificationRecordApp/routers/index'
import CheckingAppAppRouters from '@/views/webpc/CashierDesk/CheckingApp/routers/index'
import CardManagementAppRouters from '@/views/webpc/CashierDesk/CardManagementApp/routers/index'
import CouponListAppRoutersPc from '@/views/webpc/CashierDesk/CouponListApp/routers/index'
import MemberListRouters from '@/views/webpc/MemberManagement/MemberList/routers/index'
import MemberComebackRouters from '@/views/webpc/MemberManagement/MemberComeback/routers/index'
import SendCouponListRouters from '@/views/webpc/MemberManagement/SendCouponList/routers/index'
import OverviewAppRouters from '@/views/webpc/MemberStatistics/overviewApp/routers/index'
import RcStatisticsApp from '@/views/webpc/MemberStatistics/rcStatisticsApp/routers/index'
import GoodsAppRouters from '@/views/webpc/CreditMall/GoodsApp/routers/index'
import ExchangeListAppRouters from '@/views/webpc/CreditMall/ExchangeListApp/routers/index'
import VerifyListAppRouters from '@/views/webpc/CreditMall/VerifyListApp/routers/index'

Vue.use(Router)
export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/memberCenter'
    },
    {
      path: '/login',
      component: resolve =>
        require(['@/views/webpc/UserMgmt/login/Login.vue'], resolve)
    },
    {
      path: '/home',
      component: resolve => require(['@/components/mobile/Home.vue'], resolve),
      children: [
        // 手机端
        ...MemberCenterRouters,
        ...PublicAppRouters,
        ...RechargeCenterRouters,
        ...PayCenterRouters,
        ...BillListRouters,
        ...CouponListRouters,
        ...GoodsListRouters
      ]
    },
    {
      path: '/admin',
      component: resolve => require(['@/components/webpc/Home.vue'], resolve),
      children: [
        {
          path: '/',
          icon: 'el-icon-coin',
          name: '收银台',
          component: resolve =>
            require(['@/views/webpc/CashierDesk/index'], resolve),
          children: [
            ...RealAppRouters,
            ...CashRechargeAppRouters,
            ...CashRecordAppRouters,
            ...RechargeRecordAppRouters,
            ...CertificationRecordAppRouters,
            ...CouponListAppRoutersPc,
            ...CheckingAppAppRouters
          ]
        },
        {
          path: '/memberManagement',
          icon: 'el-icon-user',
          name: '会员管理',
          component: resolve =>
            require(['@/views/webpc/MemberManagement/index'], resolve),
          children: [
            ...MemberListRouters,
            ...MemberComebackRouters,
            ...SendCouponListRouters
          ]
        },
        {
          path: '/memberStatistics',
          icon: 'el-icon-s-data',
          name: '会员统计',
          component: resolve =>
            require(['@/views/webpc/MemberStatistics/index'], resolve),
          children: [
            ...OverviewAppRouters,
            ...RcStatisticsApp
          ]
        },
        {
          path: '/creditMall',
          icon: 'el-icon-box',
          name: '积分商城',
          component: resolve =>
            require(['@/views/webpc/CreditMall/index'], resolve),
          children: [
            ...GoodsAppRouters,
            ...ExchangeListAppRouters,
            ...VerifyListAppRouters
          ]
        },
        {
          path: '/cardManagement',
          icon: 'el-icon-bank-card',
          name: '实体卡管理',
          component: resolve =>
            require(['@/views/webpc/CardManagement/index'], resolve),
          children: [
            ...CardManagementAppRouters
          ]
        },
        ...UserMgmtRouters
      ]
    },
    {
      path: '/superlogin',
      component: resolve =>
        require(['@/views/webpc/UserMgmt/superlogin/Login.vue'], resolve)
    },
    {
      path: '/rechargeCouponList',
      component: resolve =>
        require(['@/views/webpc/SuperManagement/RechargeCouponApp/rechargeCouponList.vue'], resolve)
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js